import { computed, type Ref } from 'vue'
import scssVariables from '@/assets/scss/scssVariables'

import {
  STATUS_RESOURCE_ALLOCATION,
  type ResourceAllocationStatus,
  STATUS_RESOURCE_ALLOCATION_LOOKUP_LABEL,
} from '@/constants/persoplan'

import { lookup } from '@/utilities/misc'
import type { Nilable } from '@/types/misc'

export { type ResourceAllocationStatus, STATUS_RESOURCE_ALLOCATION }

interface Options {
  status: Ref<Nilable<ResourceAllocationStatus>>
}

const colors = {
  confirmed: scssVariables.color['status-resourceAllocation-confirmed'],
  requested: scssVariables.color['status-resourceAllocation-requested'],
  cancelled: scssVariables.color['status-resourceAllocation-cancelled'],
  considered: scssVariables.color['status-resourceAllocation-considered'],
  reserved: scssVariables.color['status-resourceAllocation-reserved'],
} as const satisfies Record<ResourceAllocationStatus, string>

export function useResourceAllocationStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusResourceAllocation-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  const label = computed(() => {
    return lookup(options.status.value, STATUS_RESOURCE_ALLOCATION_LOOKUP_LABEL)
  })

  return {
    classes,
    color,
    label,
  }
}
